/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";


/**
 *
 * @class BatchRowHeaderRenderer
 *
 * support for our own custom row header column
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
export class BatchRowHeaderRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** current value of the cell */
  public value: any = null;

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    const style              = `color: rgba(245, 245, 245, 0.64);`;

    this.gui                 = document.createElement('div');
    this.gui.style.textAlign = "left";
    this.gui.innerHTML       = `<span style="${style}"></span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    this.value = params?.value;

    const style = `color: rgba(245, 245, 245, 0.64);`;

    if (!this.value) {

      this.gui.innerHTML = `<style="${style}"></span>`;
      return ;
    }







    /* render */

    this.gui.innerHTML = `<span style="${style}">${this.value}</span>`;

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
